class NotesConfigurationModel {
    public EncounterContexts: string[] = [];
    public DisplayVisitDiagnosis: boolean = false;
}

export { NotesConfigurationModel };
